<template>
  <div id="adminRecords">
    <div class="adminRecords-box">
      <div class="data-top">
        <div class="item">
          <div class="item-number" style="color: #1989fa">
            <b>{{ topList.absentees || 0 }}</b
            ><span> 人 </span>
          </div>
          <div>缺勤人数</div>
        </div>
        <div class="item">
          <div class="item-number" style="color: red">
            <b>{{ topList.lateNumber || 0 }}</b
            ><span> 人 </span>
          </div>
          <div>迟到人数</div>
        </div>
        <div class="item">
          <div class="item-number" style="color: red">
            <b>{{ topList.earlyNumber || 0 }}</b
            ><span> 人 </span>
          </div>
          <div>早退人数</div>
        </div>
      </div>
      <div class="select-box">
        <div class="search">
          <van-search
            v-model="params.staffName"
            @input="onLoad(1)"
            placeholder="请输入员工姓名进行搜索"
          >
            <van-icon
              slot="left-icon"
              name="search"
              @click="onLoad(1)"
              style="color: #fff"
            ></van-icon>
          </van-search>
          <!-- <van-field v-model="params.staffName" placeholder="请输入员工姓名进行搜索" clearable @clear="onClear(1)">
            <van-icon slot="right-icon" name="search" @click="onLoad(1)" style="color:#fff"></van-icon>
          </van-field> -->
        </div>
        <div class="search-box">
          <div @click="jobsShow = true" class="time-div" style="width: 80px">
            <span>{{ params.postOffice || '岗位' }}</span>
            <van-icon :name="jobsShow ? 'arrow-up' : 'arrow-down'" />
          </div>

          <div class="search-left">
            <div class="search-left-btn">
              <div
                :class="['item', activeIndex === i ? 'active' : '']"
                v-for="(item, i) in dataList"
                :key="`data-${i}`"
                @click="fnActive(i)"
              >
                {{ item.title }}
              </div>
            </div>
            <div class="search-box-item">
              <div class="search-box-item-cell">
                <div class="pick-timer" v-if="activeIndex === 0">
                  <div class="r-time">
                    <div @click="dateShow = true" class="time-div">
                      <span>{{ dayTitle }}</span>
                      <van-icon :name="dateShow ? 'arrow-up' : 'arrow-down'" />
                    </div>
                    <van-popup v-model="dateShow" position="bottom" round>
                      <van-datetime-picker
                        v-model="params.recordDate"
                        type="date"
                        :formatter="formatterYear"
                        title="选择年月日"
                        :min-date="minDate"
                        :max-date="maxDate"
                        @cancel="cancelBtn"
                        @confirm="confirmBtn"
                      />
                    </van-popup>
                  </div>
                </div>
                <div class="pick-timer" v-else>
                  <div class="r-time">
                    <div @click="monthShow = true" class="time-div">
                      <span>{{ monthTitle }}</span>
                      <van-icon :name="monthShow ? 'arrow-up' : 'arrow-down'" />
                    </div>
                    <van-popup v-model="monthShow" position="bottom" round>
                      <van-datetime-picker
                        v-model="params.recordDate"
                        type="year-month"
                        title="选择年月"
                        :min-date="minDate"
                        :max-date="maxDate"
                        :formatter="formatter"
                        @cancel="fnDaycancelBtn"
                        @confirm="fnDayConfirmBtn"
                      />
                    </van-popup>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <van-popup v-model="jobsShow" position="bottom" round>
            <van-picker
              v-model="params.postOffice"
              title="岗位"
              show-toolbar
              :columns="jobsList"
              @confirm="onJobsConfirm"
              @cancel="onJobsCancel"
            />
          </van-popup>
        </div>

        <div class="search-box" style="justify-content: flex-end">
          <van-button
            type="info"
            size="small"
            class="exportExcel"
            @click="$router.push('/lishui/exportAttendance')"
            >导出报表</van-button
          >
        </div>
      </div>

      <van-list
        class="list-box"
        :finished-text="list.length === 0 ? '' : '~已经到底了~'"
        v-model="loading"
        :finished="finished"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        v-if="list.length > 0"
        @load="onLoad"
      >
        <div
          class="list-box-item"
          v-for="(item, index) in list"
          :key="`list-${index}`"
          @click="gotoDetail(item)"
        >
          <div class="info">{{ item.staffName }}</div>
          <div class="info">{{ item.postOffice }}</div>
          <div class="count-clock">正常打卡天数：{{ item.nomal }}天</div>
        </div>
      </van-list>
      <van-empty v-if="list.length === 0" description="暂无打卡记录" />
    </div>
  </div>
</template>

<script>
import * as API from '@api/lishui/index'
import { Toast } from 'vant'
import { getLocalStorage, format } from '@utils'
export default {
  name: 'AdminRecords',
  props: {},
  data() {
    return {
      str: '-',
      dateShow: false, // 年份弹框默认不显示
      monthShow: false, // 月份弹框默认不显示
      jobsShow: false, // 职位弹框默认不显示
      jobsList: [], // 岗位列表
      dayTitle: '', // 日选择
      monthTitle: '', // 按日
      topList: {},
      params: {
        staffName: null, // 员工名称
        creditCode: null,
        postOffice: null, // 岗位
        recordDate: new Date(),
        pageNum: 1,
        pageSize: 10
      },
      totalRecord: 0,
      // 列表加载
      loading: false,
      finished: false,
      error: false,
      minDate: new Date(2020, 12, 30),
      maxDate: new Date(2080, 12, 30),
      activeIndex: 0, // 选择按日 或按月
      dataList: [{ title: '按日' }, { title: '按月' }],
      list: []
    }
  },
  created() {
    const info = getLocalStorage('lishuiUserInfo')
      ? JSON.parse(getLocalStorage('lishuiUserInfo'))
      : {}
    this.params.creditCode = info ? info['creditCode'] : null
    // 获取当前年月日

    this.fnCurrent()
    this.getEntPostOffice()
  },
  mounted() { },
  watch: {},
  methods: {
    // 跳转员工考勤详情页
    gotoDetail(item) {
      // console.log(item)

      this.$router.push({
        path: '/lishui/clockRecords',
        query: { mobile: item.mobile }
      })
    },
    onJobsConfirm(val) {
      this.params.postOffice = val === '全部' ? '' : val
      this.jobsShow = false
      this.onLoad(1)
    },
    onJobsCancel() {
      this.jobsShow = false
    },
    fnCurrent() {
      const nowDate = new Date()
      const date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate()
      }
      const newmonth = date.month >= 10 ? date.month : '0' + date.month
      const day = date.date >= 10 ? date.date : '0' + date.date
      if (this.activeIndex === 0) {
        this.dayTitle = date.year + '-' + newmonth + '-' + day
      } else {
        this.monthTitle = date.year + '-' + newmonth
      }
      // this.onLoad(1) // 获取数据
    },
    fnActive(i) {
      this.activeIndex = i
      this.params.recordDate = new Date()
      this.fnCurrent()
      this.onLoad(1)
    },
    // 年月日
    formatterYear(type, val) {
      if (type === 'year') {
        return `${val}年`
      } else if (type === 'month') {
        return `${val}月`
      } else if (type === 'day') {
        return `${val}日`
      }
    },
    // 年月
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`
      } else if (type === 'month') {
        return `${val}月`
      }
      return val
    },
    // 按日取消
    cancelBtn() {
      this.dateShow = false
    },
    // 按日确定
    confirmBtn(value) {
      this.dayTitle = format(value)
      this.dateShow = false
      this.onLoad(1)
    },
    // 按月取消
    fnDaycancelBtn() {
      this.monthShow = false
    },
    // 按月确定
    fnDayConfirmBtn(value) {
      const text = format(value)
      this.monthTitle = text.substring(0, 7)

      this.monthShow = false
      this.onLoad(1)
    },
    // 搜索清除
    onClear(num) {
      this.params.staffName = null
      this.params.pageNum = 1
      this.onLoad(1)
    },

    /**
     * @description 岗位下拉框
     */
    getEntPostOffice() {
      API.getEntPostOffice({ creditCode: this.params.creditCode }).then(
        response => {
          let res = response.data
          if (res.code == '0000') {
            this.jobsList = ['全部', ...res.data]
            // this.onLoad(1)
          }
        }
      )
    },

    // 获取列表
    getList(param) {
      // let param = {...this.params}
      this.loading = true
      API.listEntClocked(param)
        .then(response => {
          let res = response.data
          if (res.code === '0000') {
            if (this.params.pageNum == 1) {
              this.topList.absentees = res.data.absentees
              this.topList.earlyNumber = res.data.earlyNumber
              this.topList.lateNumber = res.data.lateNumber
              this.list = (res.data && res.data.pageWrapper.results) || []
            } else {
              this.list = this.list.concat(
                (res.data && res.data.pageWrapper.results) || []
              )
            }

            this.loading = false
            // 数据全部加载完成
            if (this.params.pageNum < res.data.pageWrapper.totalPage) {
              this.finished = false
              this.params.pageNum++
            } else {
              this.finished = true
            }
          } else {
            Toast('查询失败')
          }
        })
        .catch(() => {
          this.error = true
        })
    },

    onLoad(num) {
      if (num) {
        this.params.pageNum = 1
        this.finished = false
        this.loading = true
        this.list = []
      }
      let recordDate
      if (this.params.recordDate) {
        if (this.activeIndex === 0) {
          recordDate = format(this.params.recordDate).substring(0, 10)
        } else if (this.activeIndex === 1) {
          recordDate = format(this.params.recordDate).substring(0, 7)
        }
      }

      // 为了不改变值
      const params = {
        recordDate: recordDate,
        staffName: this.params.staffName, // 员工名称
        postOffice: this.params.postOffice, // 岗位
        creditCode: this.params.creditCode,
        pageNum: this.params.pageNum,
        pageSize: 10
      }
      this.getList(params)
    },
    // 跳转至员工个人考勤页面
    goToWatch(item) {
      this.$router
        .push({
          path: '/lishui/adminWatch',
          query: {
            creditCode: item.creditCode,
            mobile: item.mobile,
            recordDate: item.recordDate
          }
        })
        .catch(() => { })
    }
  },
  components: {}
}
</script>

<style lang="scss" scoped>
.adminRecords-box {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  padding: 20px 20px 60px;
  height: calc(100vh - 104px);
  overflow-y: auto;
  .data-top {
    background: #fff;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    .item {
      width: 50%;
      display: flex;
      flex-direction: column;
      text-align: center;
      margin: 25px 0;
      .item-number {
        color: #333333;
        b {
          font-size: 20px;
          font-weight: 700;
          margin-bottom: 10px;
        }
      }
    }
    .item:nth-child(-n + 2) {
      border-right: 1px solid #cccccc;
    }
  }
  .select-box {
    margin: 10px 0;
    .search-left {
      display: flex;
      justify-content: flex-start;
      align-content: center;
      &-btn {
        margin-right: 10px;
        display: flex;
        justify-content: flex-start;
        align-content: center;
        border: 1px solid #0080ff;
        border-radius: 2px;
        .item {
          color: #0080ff;
          padding: 3px 8px;
        }
        .active {
          color: #fff;
          background: #0080ff;
        }
      }
    }
    .time-div {
      width: 120px;
      padding: 0 5px;
      height: 32px;
      border-radius: 20px;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: space-around;
      color: #333;
      font-size: 14px;
    }
    .search-box {
      margin: 10px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .exportExcel {
        border-radius: 20px;
      }
      &-item {
        display: flex;
        justify-content: space-between;
        &-cell {
          width: 130px;
          .r-time {
            display: flex;
            justify-content: flex-end;
            .time-div {
              width: 120px;
              padding: 0 5px;
              height: 32px;
              border-radius: 20px;
              background: #fff;
              display: flex;
              align-items: center;
              justify-content: space-around;
              color: #333;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
  .list-box {
    &-item {
      margin: 12px 0;
      border-radius: 5px;
      padding: 15px;
      background-color: rgba(255, 255, 255, 1);
      box-shadow: 0px 10px 60px 0px rgba(210, 214, 224, 0.5);
      .info {
        font-size: 14px;
        line-height: 28px;
      }
      .count-clock {
        margin-top: 10px;
        padding-top: 10px;
        border-top: 1px solid #666;
        line-height: 24px;
        font-size: 14px;
      }
      .commom {
        display: flex;
        flex-direction: column;
        b {
          margin: 8px 0;
          color: #333333;
          font-size: 15px;
          span {
            color: #333333;
          }
        }
        span {
          // margin: 10px 0;
          font-size: 14px;
          color: #999999;
        }
      }
      .right {
        text-align: center;
        span {
          margin: 8px 0;
        }
      }
    }
  }
}
</style>
